import { useContext } from "react";

import { LdoAuthContext } from "@nens/ldo/auth-v1";
import { Raster, rasterSchema } from "@nens/lizard/api-v4";
import { useParsedQueries } from "@nens/react-query-utils";

import { API_BASE_URL } from "../constants";
import { ApiBulkExport } from "../schemas/bulk-exports";

export function useBulkExportRasters(bulkExport: ApiBulkExport) {
  // Fetch all rasters of a bulkExport
  const { apiFetchFunction } = useContext(LdoAuthContext);

  return useParsedQueries<{ type: string; raster: Raster }>(
    bulkExport.rasters.map((bulkExportRaster) => {
      const { id, type } = bulkExportRaster;
      return {
        queryKey: ["ldo", "bulkExport-raster", bulkExport.id, type],
        fetchFunction: () =>
          apiFetchFunction(`${API_BASE_URL}/bulk-exports/${bulkExport.id}/rasters/${id}`),
        parseFunction: (json: unknown) => ({
          type,
          raster: rasterSchema.parse(json),
        }),
      };
    })
  );
}
